import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Soft 401 handling — clear stale token and let the app gently redirect.
// Other errors are returned as-is so callers can decide messaging.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const hadToken = !!localStorage.getItem("bn_token");
      localStorage.removeItem("bn_token");
      // Avoid loops on the public auth/landing pages
      if (hadToken && typeof window !== "undefined") {
        const path = window.location.pathname;
        if (path !== "/auth" && path !== "/" && !path.startsWith("/gift/")) {
          window.location.assign("/auth?mode=login");
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
